module.exports = __webpack_public_path__ + "static/img/ddb.de11c11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/buttons/ddb.png
// module id = Q2eG
// module chunks = 0